import { createModel } from '@rematch/core';

export interface ErrorState {
  title: string;
  message: string;
}

export interface ErrorPayload {
  title: string;
  message: string;
}

const setError = function handleSetError(
  state: ErrorState,
  payload: ErrorPayload
): ErrorState {
  return {
    ...state,
    title: payload.title,
    message: payload.message
  };
};

const clearError = function handleClearError(state: ErrorState): ErrorState {
  return {
    ...state,
    title: '',
    message: ''
  };
};

const error = createModel({
  state: {
    title: '',
    message: ''
  },
  reducers: {
    setError,
    clearError
  }
});

export default error;
